import Image from "next/image"
import { useAmp } from "next/amp"

interface AuthorImageProps {
  source: string
}

export function AuthorImage({ source }: AuthorImageProps) {
  const isAmp = useAmp()

  return (
    <div className="relative mr-3 w-15 h-15 mobile-m:w-16 mobile-m:h-16 tablet:mr-4">
      {isAmp ? (
        <amp-img width={64} height={64} src={source} layout="fixed" />
      ) : (
        <Image
          src={source}
          layout="fill"
          alt="Author"
          className="rounded-full"
          unoptimized={true}
        />
      )}
    </div>
  )
}
